import { useTheme } from 'styled-components';

export const CopyIcon: React.FC<{ color?: string }> = ({ color }) => {
  const theme = useTheme();
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1818 0.5H1.45455C0.654545 0.5 0 1.15455 0 1.95455V12.1364H1.45455V1.95455H10.1818V0.5ZM9.45455 3.40909L13.8182 7.77273V15.0455C13.8182 15.8455 13.1636 16.5 12.3636 16.5H4.35636C3.55636 16.5 2.90909 15.8455 2.90909 15.0455L2.91636 4.86364C2.91636 4.06364 3.56364 3.40909 4.36364 3.40909H9.45455ZM8.72727 8.5H12.7273L8.72727 4.5V8.5Z"
        fill={color ?? theme.secondary.softBlue2}
      />
    </svg>
  );
};
